import { depositConfigItemType, depositConfigType, paymentResultPay3000Type, paymentResultType } from '@sharedTemplates/deposit/Deposit.model';
import { DepositFrameDialog } from '@components/deposit-frame-dialog';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { pushToDataLayer } from '@helpers/gtm.util';
import { TranslateService } from '@services/translate.service';
import { Injectable } from '@angular/core';

@Injectable()
export class DepositService {
  amount: any = '';
  lastSuccesfulDeposit: {
    LastDepositAmount: number;
    LastDepositType: number;
    Description: string;
    PaymentType: string;
    depositItems: any;
  };
  public selectedDepositItem = {
    MaxValue: null,
    MinValue: null,
    Description: '',
    DepositTypeId: null,
    paymentMethodId: '',
    result: {
      finished: false,
      success: false,
      message: '',
    },
  };

  public selectedDepositConfigItem: depositConfigItemType = {
    id: null,
    paymentMethod: null,
    resultType: null,
    description: '',
    paymentMethodId: '',
    isSkipAmount: false,
    iconName: '',
  };

  ismobile: boolean;
  constructor(public dialog: MatDialog, public _ApiService: ApiService, public _UserHelper: UserHelper, public _UiHelper: UiHelper, public _TranslateService: TranslateService) {
    this.ismobile = this._UiHelper.windowsWidth < 990 ? true : false;
  }

  public depositConfig: depositConfigType = {
    p1012: {},
  };

  public async confirmButton() {
    const depositConfigItem = this.selectedDepositConfigItem;
    if (depositConfigItem) {
      this.depositPaymentAction(depositConfigItem).then();
    }
  }

  public async depositPaymentAction(configItem: depositConfigItemType) {
    this._UiHelper.setLoadingDialog(true);
    const actionResult: paymentResultType = await configItem.paymentMethod();
    const result = configItem.resultType(actionResult, configItem);
    this.selectedDepositItem.result = result;
    if (result.success === true) {
      setTimeout(() => {
        this._UiHelper.depositCardDimmer = false;
        this.selectedDepositItem = {
          MaxValue: null,
          MinValue: null,
          Description: '',
          DepositTypeId: null,
          paymentMethodId: '',
          result: {
            finished: false,
            success: false,
            message: '',
          },
        };
      }, 4000);
    }
    this._UiHelper.setLoadingDialog(false);
  }

  public paymentResult3(paymentResult: string, configItem: depositConfigItemType): { success: boolean; message: string; finished: boolean } {
    const paymentJsonResult: paymentResultType = JSON.parse(paymentResult);
    this.pushDataLayerAction(paymentJsonResult.result, configItem.description);
    if (paymentJsonResult.result === 'success') {
      const dialogRef = this.dialog.open(DepositFrameDialog, {
        width: '100%',
        height: '100%',
        panelClass: 'transcationDialog-full-width',
        data: {
          depositurl: paymentJsonResult.desc,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.updateUserData();
      });

      return { success: true, message: '', finished: true };
    } else {
      this._UiHelper.errorSnackBar(paymentJsonResult.desc, '');
      return { success: false, message: paymentJsonResult.desc, finished: true };
    }
  }

  public paymentResult4(paymentResult: string, configItem: any): { success: boolean; message: string; finished: boolean } {
    const paymentJsonResult: any = JSON.parse(paymentResult);
    this.pushDataLayerAction(paymentJsonResult.result, configItem.desc);
    if (paymentJsonResult.result === 'success') {
      const dialogRef = this.dialog.open(DepositFrameDialog, {
        width: window.innerWidth > 990 ? '80%' : '100%',
        height: window.innerWidth > 990 ? '80%' : '100%',
        panelClass: 'transcationDialog-full-width',
        data: {
          depositurl: paymentJsonResult.url,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.updateUserData();
      });

      return { success: true, message: '', finished: true };
    } else {
      this._UiHelper.errorSnackBar(paymentJsonResult.desc, '');
      return { success: false, message: paymentJsonResult.desc, finished: true };
    }
  }

  public paymentResult1(paymentResult: string, configItem: depositConfigItemType): { success: boolean; message: string; finished: boolean } {
    const paymentJsonResult: paymentResultType = JSON.parse(paymentResult);
    this.pushDataLayerAction(paymentJsonResult.result, configItem.description);
    if (paymentJsonResult.result === 'success') {
      window.document.location = paymentJsonResult.desc;
    } else {
      this._UiHelper.errorSnackBar(paymentJsonResult.desc, '');
      return { success: false, message: paymentJsonResult.desc, finished: true };
    }
  }

  public paymentResult5(paymentResult: string, configItem: any): { success: boolean; message: string; finished: boolean } {
    const paymentJsonResult: any = JSON.parse(paymentResult);
    this.pushDataLayerAction(paymentJsonResult.result, configItem.description);
    if (paymentJsonResult.StatusCode === 200) {
      window.document.location = paymentJsonResult.Link;
    } else {
      this._UiHelper.errorSnackBar(paymentJsonResult.Message, '');
      return { success: false, message: paymentJsonResult.Message, finished: true };
    }
  }
  public paymentResult2(paymentResult: string, configItem: depositConfigItemType): { success: boolean; message: string; finished: boolean } {
    const paymentJsonResult: paymentResultPay3000Type = JSON.parse(paymentResult);
    this.pushDataLayerAction(paymentJsonResult.Status === 'true' ? 'success' : 'failed', configItem.description);

    if (paymentJsonResult.Status === 'true') {
      const info_message = this._TranslateService.instant('arenaPayInfoMessage');

      return { success: true, message: info_message, finished: true };
    } else {
      let errorMessage: any = paymentJsonResult.ErrorMessage;
      try {
        errorMessage = JSON.parse(errorMessage);
        return { success: false, message: errorMessage?.error, finished: true };
      } catch (e) {
        return { success: false, message: paymentJsonResult.ErrorMessage, finished: true };
      }
    }
  }

  private updateUserData() {
    this._ApiService
      .getClient()
      .then(result => {
        this._UserHelper.setUser(result);
      })
      .catch();
  }

  private pushDataLayerAction(type, description) {
    pushToDataLayer({
      event: type === 'success' ? 'deposit' : 'deposit_failed',
      method: description,
      amount: this.amount,
      currency: this._UserHelper.customerUser.Symbol,
    });
  }

  onPageLoad() {
    const f = this.generateUUID();
    const s = 'IBAEntertainment_8G3ZAW2PR4AX6_RT';
    const sandbox = true;
    this.createOrUpdateParamsScriptTag(f, s, sandbox);
    this.loadOrReloadPaypalScript();
    return f;
  }

  generateUUID() {
    let d = new Date().getTime(); //Timestamp
    let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16;
      if (d > 0) {
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  createOrUpdateParamsScriptTag(_f, _s, _sandbox) {
    const fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
    const existingScriptElement = document.querySelector(`[fncls="${fncls}"]`);
    const jsonData = {
      f: _f,
      s: _s,
      sandbox: _sandbox,
    };

    if (existingScriptElement) {
      existingScriptElement.textContent = JSON.stringify(jsonData);
    } else {
      const jsonData = {
        f: _f,
        s: _s,
        sandbox: true,
      };
      const scriptElement = document.createElement('script');
      scriptElement.setAttribute('type', 'application/json');
      scriptElement.setAttribute('fncls', fncls);
      scriptElement.textContent = JSON.stringify(jsonData);
      document.body.appendChild(scriptElement);
    }
  }

  loadOrReloadPaypalScript() {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = 'https://c.paypal.com/da/r/fb.js';
    const existingScript = document.querySelector('script[src="https://c.paypal.com/da/r/fb.js"]');
    if (existingScript) {
      existingScript.remove();
    }
    document.body.appendChild(scriptElement);
  }
}
